import { styled } from "styled-components";

export const ListAmount = styled.div`
  font-size: 24px;
  font-weight: 600;
`;
